import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { cn, getCoursePath } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

type CourseCardProps = {
  title: string;
  language: "python" | "javascript";
  linkUrl?: string;
  iconUrl?: string;
  locked?: boolean;
};

const CourseCard = ({
  title,
  language,
  linkUrl,
  iconUrl,
  locked = false,
}: CourseCardProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (locked || !linkUrl) return;
    // Use the title to create a consistent URL path
    const coursePath = getCoursePath(title);
    // navigate(`/course/${coursePath}/lesson/1.1`);
    navigate(linkUrl);
  };

  const card = (
    <Card
      className={cn(
        "p-6 cursor-pointer hover:shadow-lg transition-all duration-300 bg-white",
        locked && "opacity-50",
      )}
      onClick={handleClick}
    >
      <CardContent className="p-0 flex flex-col items-center gap-4">
        <div className="rounded-full bg-gray-50 p-6">
          <img src={iconUrl} alt={language} className="w-12 h-12" />
        </div>
        <div className="flex items-center gap-2">
          <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
          {locked && <Lock className="h-4 w-4 text-gray-400" />}
        </div>
      </CardContent>
    </Card>
  );

  if (locked) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{card}</TooltipTrigger>
        <TooltipContent>
          <p>Purchase a subscription to unlock</p>
        </TooltipContent>
      </Tooltip>
    );
  }

  return card;
};

export default CourseCard;
